import React from 'react';
import { useScrollFade } from '../hooks/useScrollFade';
import { useConsultationForm } from './ConsultationFormContext';
export function BeforeAfterSection() {
  const {
    ref,
    isVisible
  } = useScrollFade();
  const {
    openForm
  } = useConsultationForm();
  const cases = [{
    id: 3,
    patient: 'Patient, 35 · Skin Rejuvenation',
    sessions: 'After 4 Sessions',
    image: 'https://cdn.magicpatterns.com/uploads/tnuEEoGvR67udxGwecpkph/RF_Microneedling1.webp'
  }, {
    id: 2,
    patient: 'Patient, 38 · Texture & Pores',
    sessions: 'After 2 Sessions',
    image: 'https://cdn.magicpatterns.com/uploads/3g1jGvN6ftqEn75ftwnZ4H/RF_Microneedling2.jpg'
  }, {
    id: 1,
    patient: 'Patient, 42 · Lower Face & Neck',
    sessions: 'After 3 Sessions',
    image: 'https://cdn.magicpatterns.com/uploads/68JPGyxWzk7Jq94HFFG3Ux/RF_Microneedling0.jpg'
  }];
  return <section className="py-24 bg-white relative" data-id="element-15">
      <div className="container mx-auto px-4 md:px-8 max-w-6xl" data-id="element-16">
        <div ref={ref} className={`text-center mb-16 transition-all duration-1000 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`} data-id="element-17">
          <h2 className="font-serif text-3xl md:text-4xl text-text-dark" data-id="element-18">
            Real Results. Real Patients.
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-12 md:gap-8" data-id="element-19">
          {cases.map((item, index) => <div key={item.id} className={`flex flex-col transition-all duration-1000 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`} style={{
          transitionDelay: `${index * 200 + 200}ms`
        }} data-id="element-20">
              <div className="relative aspect-[4/3] w-full overflow-hidden rounded-sm mb-6 shadow-md" data-id="element-21">
                <img src={item.image} alt={`Before and after results for ${item.patient}`} className="w-full h-full object-cover" data-id="element-22" />
              </div>
              <div className="text-center" data-id="element-23">
                <p className="font-serif text-lg text-text-dark mb-1" data-id="element-24">
                  {item.patient}
                </p>
                <p className="text-sm text-sage uppercase tracking-widest" data-id="element-25">
                  {item.sessions}
                </p>
              </div>
            </div>)}
        </div>

        <div className={`text-center mt-12 transition-all duration-1000 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`} style={{
        transitionDelay: '800ms'
      }} data-id="element-26">
          <button onClick={openForm} className="inline-block bg-gold hover:bg-gold/90 text-white font-medium px-10 py-4 rounded-sm tracking-wide uppercase text-sm transition-all duration-300 hover:shadow-lg" data-id="element-27">
            Book A Consultation
          </button>
        </div>
      </div>
    </section>;
}